import AuthorizationHelper from '@auth/services/authorization.helper';

const routes = [
  {
    path: 'templates',
    name: 'admin-templates',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.templates],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-templates" */ '@tools/pages/template-table/template-table.vue'
      ),
  },
];

export const mainToolRoutes = [];

export default routes;
